export default __webpack_public_path__ + "static/media/cine-two.f2197b27.png";